import type { TBoard, PieceSymbol } from './types';

export const BOARD_SIZE = 8;

export const DEFAULT_TURN_DURATION_MS = 10 * 60 * 1000;

const BACK_RANK: PieceSymbol[] = ['r', 'n', 'b', 'q', 'k', 'b', 'n', 'r'];

export const PIECE_ORDER: readonly string[] = [
  ...BACK_RANK.map((t) => t.toUpperCase()),
  ...Array(8).fill('P'),
  ...Array(8).fill('p'),
  ...BACK_RANK,
];

export function createInitialBoard(): TBoard {
  const board: TBoard = Array(BOARD_SIZE)
    .fill(null)
    .map(() => Array(BOARD_SIZE).fill(null));

  for (let col = 0; col < BOARD_SIZE; col++) {
    board[0][col] = { color: 'w', type: BACK_RANK[col] };
    board[1][col] = { color: 'w', type: 'p' };
    board[6][col] = { color: 'b', type: 'p' };
    board[7][col] = { color: 'b', type: BACK_RANK[col] };
  }

  return board;
}

export function createTestPromotionBoard(): TBoard {
  const board: TBoard = Array(BOARD_SIZE)
    .fill(null)
    .map(() => Array(BOARD_SIZE).fill(null));
  board[0][4] = { color: 'w', type: 'k' };
  board[6][4] = { color: 'w', type: 'p' };
  board[7][0] = { color: 'b', type: 'k' };
  return board;
}

export function createTestEnPassantBoard(): TBoard {
  const board: TBoard = Array(BOARD_SIZE)
    .fill(null)
    .map(() => Array(BOARD_SIZE).fill(null));
  board[0][4] = { color: 'w', type: 'k' };
  board[4][4] = { color: 'w', type: 'p' };
  board[4][3] = { color: 'b', type: 'p' };
  board[7][4] = { color: 'b', type: 'k' };
  return board;
}
